import { useEffect, useRef, useState } from 'react';
import { useInView, animate } from 'framer-motion';

interface Props {
  value: number;
  duration?: number;
  decimals?: number;
  className?: string;
}

export default function AnimatedCounter({ value, duration = 1.5, decimals = 1, className }: Props) {
  const [display, setDisplay] = useState(0);
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, { once: true });

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setDisplay(v),
    });
    return () => controls.stop();
  }, [inView, value, duration]);

  return <span ref={ref} className={className}>{display.toFixed(decimals)}</span>;
}
